import React from 'react';
import styled from 'styled-components';

const SwitchOuter = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing02};
  margin-right: ${({ theme }) => theme.spacing02};

  .switch-label {
    color: ${({ theme }) => theme.colorText70};
    margin-right: ${({ theme }) => theme.spacing01};
    font-weight: ${({ theme }) => theme.fontWeightMedium};
    color: ${({ theme }) => theme.colorText70};
  }
`;

const SwitchWrap = styled.div`
  height: 24px;
  width: 40px;
  position: relative;
  border-radius: 50px;
  cursor: pointer;
  background: ${(props) => (props.checked ? props.theme.colorPrimary50 : props.theme.colorUI80)};

  input {
    cursor: pointer;
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: 0;
    margin: 0;
  }

  .switch {
    display: flex;
    align-items: center;
  }
`;

const SwitchButton = styled.div`
  position: absolute;
  top: 50%;
  height: 18px;
  width: 18px;
  background: white;
  pointer-events: none;
  border-radius: 50%;
  cursor: pointer;
  transform: ${(props) =>
    props.checked ? 'translate(calc(38px - 18px), -50%);' : 'translate(calc(0% + 2px), -50%)'};
  transition: 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) transform; ;
`;

export default function Switch({ checked, onChange, label, className }) {
  return (
    <SwitchOuter className={className ? className : ''} checked={checked}>
      <label className="switch-label" htmlFor="">
        {label}
      </label>
      <SwitchWrap checked={checked}>
        <input checked={checked} onChange={onChange} type="checkbox" />
        <SwitchButton checked={checked}></SwitchButton>
      </SwitchWrap>
    </SwitchOuter>
  );
}
